import React from 'react';
import {EntityLogo, EntityLogoProps} from "../../../../../core/components/logos/entity-logo";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {Link} from "../../../../../core/components/link/link";
import styles from "../styles/mega-header-mobile.module.scss";
import classNames from "classnames";

export class MegaHeaderModuleLogoComponentProps extends EntityLogoProps {
  isLight: Boolean;
  eager: Boolean;
  iconContainerClassName: String;
  iconClassName: String;
  device: DeviceViewModel;
  model;
  onClick: Function;
}

export const MegaHeaderModuleLogo = ({
                                       iconClassName,
                                       iconContainerClassName,
                                       device,
                                       entity,
                                       model,
                                       onClick,
                                       alt
                                     }: MegaHeaderModuleLogoComponentProps) => {

  const iconContainerProps = {
    className: iconContainerClassName,
  };

  const iconProps = {
    width: device.isSmallView ? 24 : 68,
    height: device.isSmallView ? 24 : 68,
    className: iconClassName,
    entity,
    alt
  }

  const linkProps = {
    model,
    onClick,
    className: classNames(styles.logo_link)
  }

  return (
    <Link {...linkProps}>
      <div {...iconContainerProps}>
        <EntityLogo {...iconProps} />
      </div>
    </Link>
  );
}
